export enum SystemAccountType {
  ClearSignSupport = 'ClearSignSupport',
  ClearSignAuditor = 'ClearSignAuditor'
}
